import makeHeading from '../utils';

export default makeHeading('h4');
